import { BlockComponentFactory } from '../BlockFactory'
import { GridBlockProps, GridColumnProps } from './block-props.types'
import { useBlockChildren } from '../../hooks/useBlockChildren'
import { GridBlock } from './GridBlock'
import { Fragment } from 'react'

const GridColumnChildren: React.FC<{ childBlockConfigIds?: string[] }> = ({
    childBlockConfigIds,
}) => {
    const children = useBlockChildren(childBlockConfigIds)
    return children && children.length > 0 ? children : null
}

export const GridBlockRuntimeComponent = BlockComponentFactory.createBlockComponent<GridBlockProps>(
    props => {
        const { items = [], ...restProps } = props

        const children: React.ReactNode[] = items.map((column: GridColumnProps) => (
            <Fragment key={column.id}>
                <GridColumnChildren childBlockConfigIds={column.childBlockConfigIds} />
            </Fragment>
        ))

        return <GridBlock {...restProps} items={items} children={children} />
    }
)
